import {FC} from 'react';
import {useTranslation} from 'react-i18next';
import {IconType} from 'components/Icon/types';
import Notification, {NotificationType} from 'components/Notification';

export type MessageKind =
    | 'logged_out'
    | 'expired_link_token'
    | 'expired_onetime_link_token'
    | 'expired_session_token'
    | 'invalid_link_token'
    | 'missing_link_token'
    | 'invalid_session_token'
    | 'missing_session_token'
    | 'portal_not_available'
    | 'unknown_error';

export const allMessageKinds: MessageKind[] = [
    'logged_out',
    'expired_link_token',
    'expired_onetime_link_token',
    'expired_session_token',
    'invalid_link_token',
    'missing_link_token',
    'invalid_session_token',
    'missing_session_token',
    'unknown_error',
];

export const messageKey: Record<MessageKind, string> = {
    expired_link_token: 'badLinkToken',
    expired_onetime_link_token: 'badLinkToken',
    expired_session_token: 'expiredSessionToken',
    invalid_link_token: 'badLinkToken',
    invalid_session_token: 'invalidSessionToken',
    logged_out: 'loggedOut',
    missing_link_token: 'badLinkToken',
    missing_session_token: 'missingSessionToken',
    portal_not_available: 'portalNotAvailable',
    unknown_error: 'invalidSessionToken',
};

const infoType: [NotificationType, IconType] = ['system', 'info'];
const alertType: [NotificationType, IconType] = ['alert', 'warning'];
const dangerType: [NotificationType, IconType] = ['danger', 'danger'];

export const messageType: Record<MessageKind, [NotificationType, IconType]> = {
    expired_link_token: alertType,
    expired_onetime_link_token: alertType,
    expired_session_token: alertType,
    invalid_link_token: alertType,
    invalid_session_token: alertType,
    logged_out: infoType,
    missing_link_token: alertType,
    missing_session_token: infoType,
    portal_not_available: dangerType,
    unknown_error: dangerType,
};

interface Props {
    className?: string;
    kind?: MessageKind;
}

const PortalNotification: FC<Props> = ({className, kind}) => {
    const {t} = useTranslation('Portal');

    if (!kind || !messageKey[kind]) return null;

    const [type, icon] = messageType[kind];

    return (
        <Notification className={className} icon={icon} type={type}>
            {t(`notifications.${messageKey[kind]}`)}
        </Notification>
    );
};

export default PortalNotification;
